module.exports = __webpack_public_path__ + "static/media/percentage-radio-button-selected.0f7cca01.svg";